'use client';

import { DialogActions } from '@mui/material';

import { styled } from '../../styles';

import { DialogActionsProps } from './types';

export const StyledDialogActions = styled(DialogActions)<DialogActionsProps>(
  ({ theme, size }) => ({
    justifyContent: 'center',
    padding:
      size === 'small' ? theme.spacing(0, 4, 6) : theme.spacing(0, 6, 10),
    gap: theme.spacing(4),

    '& button': {
      width: '100%',
    },
  }),
);
